import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language].footer;
  const navT = translations[language].nav;
  
  return (
    <footer className="bg-[#2c2c2c] text-white pt-16 pb-8">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-['Cormorant_Garamond'] font-semibold mb-4 text-[#D4C5B0]">
              Komorebi Homes
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              木漏れ日ホームズ
            </p>
            <p className="text-sm text-gray-400 leading-relaxed">
              {t.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#D4C5B0]">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-sm text-gray-400 hover:text-white transition-colors duration-300">
                  {navT.about}
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-400 hover:text-white transition-colors duration-300">
                  {navT.services}
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-sm text-gray-400 hover:text-white transition-colors duration-300">
                  {navT.portfolio}
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-sm text-gray-400 hover:text-white transition-colors duration-300">
                  {navT.testimonials}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors duration-300">
                  {navT.contact}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#D4C5B0]">{t.contactTitle}</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#D4C5B0] mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-400">
                  {language === 'en' 
                    ? '1-2-3 Sakura-cho, Kyoto-shi, Kyoto 600-0000, Japan'
                    : '〒600-0000 京都府京都市 桜町1-2-3'
                  }
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#D4C5B0] flex-shrink-0" />
                <span className="text-sm text-gray-400">
                  {language === 'en' ? '+81 75-123-4567' : '075-123-4567'}
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#D4C5B0] flex-shrink-0" />
                <span className="text-sm text-gray-400">info@komorebihomes.jp</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#D4C5B0]">{t.followUs}</h4>
            <p className="text-sm text-gray-400 mb-4">
              {t.followDesc}
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-[#3a3a3a] rounded-full flex items-center justify-center hover:bg-[#8B7355] transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[#3a3a3a] rounded-full flex items-center justify-center hover:bg-[#8B7355] transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[#3a3a3a] rounded-full flex items-center justify-center hover:bg-[#8B7355] transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              {t.copyright}
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors duration-300">
                {t.privacy}
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors duration-300">
                {t.terms}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;